import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import "./UserStatisticsView";
import "./TopEventParticipantsView";
import "./EventStatisticsView";
import "./AllStatisticsView"; // TODO: rename to TopOrganizationStatistics
import xamatron from "xamatron";
var StatisticsView = /** @class */ (function (_super) {
    tslib_1.__extends(StatisticsView, _super);
    function StatisticsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.showStatistics = "User";
        _this.eventNumTop = 50;
        _this.usersNumTop = 50;
        _this.organizationsNumTop = 10;
        return _this;
    }
    StatisticsView.prototype.routed = function () {
        store.page.title = this.$t("statisticsView.title");
    };
    Object.defineProperty(StatisticsView.prototype, "locale", {
        get: function () { return this.$i18n.locale; },
        enumerable: true,
        configurable: true
    });
    StatisticsView.prototype.userStatistics = function () {
        this.showStatistics = "User";
    };
    StatisticsView.prototype.eventStatistics = function () {
        this.showStatistics = "Event";
    };
    StatisticsView.prototype.topEventParticipants = function () {
        this.showStatistics = "TopUsers";
    };
    StatisticsView.prototype.topOrganizationStatistics = function () {
        this.showStatistics = "TopOrganizations";
    };
    StatisticsView.prototype.openMoreStatistics = function () {
        xamatron.openURL(this.root.getSiteUrl("public/results"));
    };
    StatisticsView = tslib_1.__decorate([
        Component
    ], StatisticsView);
    return StatisticsView;
}(Vue));
export default StatisticsView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/StatisticsView.vue
// module id = 72
// module chunks = 0